export default __webpack_public_path__ + "36c98e29ffbe60aa54201347577093e8.png";